import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';

import { withRouter } from 'react-router-dom';
// import { getOrgByID } from './graphql';
// import { apiUrl } from '../../config/properties';
import { cloudFrontCdnUrl, tomcatHost } from '../../config/properties';

export default function UploadToolingHOC(UploadToolingPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      onReturnToMainPage: PropTypes.func.isRequired,
      auth: PropTypes.shape({
        id: PropTypes.string,
        role: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
        jwtToken: PropTypes.string,
        email: PropTypes.string,
        cageCode: PropTypes.string,
      }).isRequired,
    };

    static initialState = {

      isLoading: true,
      errors: [],
      alertType: '',
      alertMessage: '',
    };

    state = WrappedComponent.initialState;

    _hideMessage = () => this.setState({ alertMessage: '', alertType: '' });

    // _handleUpload = async option => {
    //   const { onSuccess, file } = option;
    //   const reader = new FileReader();


    //   reader.readAsDataURL(file);

    //   reader.onloadend = async () => {
    //     const { cageCode } = await getOrgByID(this.props.auth.organizationId);
    //     const fileName = `${file.name}`;
    //     const config = {
    //       url: `${apiUrl}partnumbers/uploads`,
    //       method: 'post',
    //       headers: {
    //         Accept: 'application/json, application/x-www-form-urlencoded',
    //         Authorization: `Bearer ${this.props.auth.jwtToken}`,
    //         name: fileName,
    //         cage: cageCode,
    //         email: this.props.auth.email,
    //         batchtype: "T",
    //       },
    //       data: reader.result.substr(reader.result.indexOf(',') + 1),
    //       onUploadProgress: ({ total, loaded }) => {
    //         this.setState({
    //           alertType: 'info',
    //           alertMessage: ` uploading ${Math.round(
    //             (loaded / total) * 100,
    //           ).toFixed(2)}%`,
    //         });
    //       },
    //     };
    //     // Succeeded, is redundant here. onSuccess vs onFailure

    //     try {
    //       const res = await Axios(config);
    //       onSuccess(res.data);
    //       this.setState({
    //         alertType: 'success',
    //         alertMessage:
    //           'Upload successful! Your file has been successfully uploaded although it may take up to 30 minutes to see your results.',
    //       });
    //     } catch (error) {
    //       this.setState({
    //         alertType: 'warning',
    //         alertMessage:
    //           'File failed to upload. It seems something went wrong uploading your file.\n Please try again in a few minutes. If the problem persists, please contact support',
    //       });
    //     }
    //   };
    // };

    _handleUpload = async option => {
      const { onSuccess, file } = option;
      const formData = new FormData();
      formData.set("fileToUpload", file);
      formData.set("cage", this.props.auth.cageCode);
      formData.set("email", this.props.auth.email);
      formData.set("type", "T");

      // Handle both cases: tomcatHost with or without protocol
      let tomcatHostPath;
      if (tomcatHost.startsWith('http')) {
        tomcatHostPath = tomcatHost;
      } else if (cloudFrontCdnUrl && cloudFrontCdnUrl.trim() !== '') {
        tomcatHostPath = `${cloudFrontCdnUrl}/${tomcatHost}`;
      } else {
        // Fallback to localhost if no CloudFront URL is configured
        tomcatHostPath = `http://localhost:8080/iconrest`;
      }

      console.log('Upload URL Debug:', {
        tomcatHost,
        cloudFrontCdnUrl,
        tomcatHostPath,
        finalUrl: `${tomcatHostPath}/tools/upload-tooling-management`
      });
      const config = {
        url: `${tomcatHostPath}/tools/upload-tooling-management`,
        method: 'post',
        headers: {
          Authorization: `Bearer ${this.props.auth.jwtToken}`,
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
        onUploadProgress: ({ total, loaded }) => {
          this.setState({
            alertType: 'info',
            alertMessage: ` uploading ${Math.round(
              (loaded / total) * 100,
            ).toFixed(2)}%`,
          });
        },
      };

      try {
        console.log('Sending request to:', config.url);
        console.log('Request headers:', config.headers);
        console.log('Form data keys:', Array.from(formData.keys()));

        const res = await Axios(config);
        console.log('Upload response:', res);
        onSuccess(res.data);

        // Parse the response to show detailed results
        const responseData = res.data;
        let message = 'Upload successful! ';

        if (responseData.totalProcessed) {
          message += `Processed ${responseData.totalProcessed} records. `;
          message += `Success: ${responseData.successCount}, Failed: ${responseData.failureCount}. `;

          if (responseData.failureCount > 0 && responseData.errors) {
            message += `Errors: ${responseData.errors.slice(0, 3).join(', ')}`;
            if (responseData.errors.length > 3) {
              message += ` and ${responseData.errors.length - 3} more errors.`;
            }
          }
        }

        this.setState({
          alertType: responseData.failureCount > 0 ? 'warning' : 'success',
          alertMessage: message,
        });
      } catch (error) {
        let errorMessage = 'File failed to upload. ';

        if (error.response && error.response.data && error.response.data.msg) {
          errorMessage += error.response.data.msg;
        } else {
          errorMessage += 'It seems something went wrong uploading your file. Please try again in a few minutes. If the problem persists, please contact support.';
        }

        this.setState({
          alertType: 'danger',
          alertMessage: errorMessage,
        });
      }
    };

    render() {
      const { onReturnToMainPage } = this.props;
      const {
        alertType,
        alertMessage,
      } = this.state;

      // Configure Page
      const pageProps = {
        handleUpload: this._handleUpload,
        alertType,
        alertMessage,
        hideMessage: this._hideMessage,
        onReturnToMainPage,
      };

      return <UploadToolingPage {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/components/UploadTooling/UploadToolingHOC.jsx